export default __webpack_public_path__ + "static/media/2342.2f108731.png";